<template>
	<SuiActionBarToggleItem :label="$t('columns')" icon="board">
		<template #default="{ closeDropdown }">
			<div class="task-list-column-toggle">
				<SuiSortList
					v-model="sortableColumns"
					:fixed-header-items="fixedColumnsStart"
					class="task-list-column-toggle__sort-list"
				/>

				<div class="task-list-column-toggle__footer">
					<SuiButton
						variant="primary"
						@click="applyColumnSettings(closeDropdown)"
					>
						{{ $t('apply') }}
					</SuiButton>
				</div>
			</div>
		</template>
	</SuiActionBarToggleItem>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import {
	SuiActionBarToggleItem,
	SuiButton,
	SuiSortList,
	type SuiSortListItem,
} from '@developers/scoro-ui';
import { useTaskListColumnSettings } from './useTaskListColumnSettings';
import { STORAGE_KEY, SORTABLE_COLUMN_IDS } from './constants';

export interface TaskListColumnToggleProps {
	storageKey?: string;
	availableColumns?: readonly string[];
}

const { storageKey = STORAGE_KEY, availableColumns = SORTABLE_COLUMN_IDS } =
	defineProps<TaskListColumnToggleProps>();

const { settings, getFixedHeaderItems, getSortableList, saveSettings } =
	useTaskListColumnSettings({
		storageKey,
		availableColumns,
	});

const fixedColumnsStart = computed(() => getFixedHeaderItems());
const sortableColumns = ref<SuiSortListItem[]>(getSortableList());

watch(
	settings,
	() => {
		sortableColumns.value = getSortableList();
	},
	{ deep: true }
);

const applyColumnSettings = (closeDropdown: () => void) => {
	saveSettings(sortableColumns.value);
	closeDropdown();
};
</script>

<style scoped lang="scss">
.task-list-column-toggle {
	min-width: 33.5rem;
	max-width: 40rem;

	&__sort-list {
		max-height: calc(50vh - 16rem);
		overflow: auto;
		padding: 1rem 0;
	}

	&__footer {
		display: flex;
		justify-content: center;
		padding: 0.5rem 0 1.5rem;
	}
}
</style>
